import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  InputAdornment,
  OutlinedInput,
  IconButton,
  Grid,
  Typography,
  FormControl,
} from "@material-ui/core";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";
import { useStyles, ProfileLogic, validator } from "./profile.module";
import { VisibilityOff, Visibility } from "@material-ui/icons";
import ButtonDefault from "../shared/button/button";
import AlertMessage from "../shared/alert/alert";

const ResetPasswordAccordion = () => {
  const classes = useStyles();
  const {
    current,
    changeState,
    changePassword,
    handleChange,
    handleClickShowCurrentPassword,
    handleClickShowNewPassword,
    handleClickShowConfirmNewPassword,
    handleMouseDownPassword,
    values,
    errors,
    buttonDisabled,
    translator,
  } = ProfileLogic(() => validator);

  return (
    <Accordion onChange={changeState(0)}>
      <AccordionSummary
        className={classes.root}
        expandIcon={
          current === 0 ? (
            <RemoveCircleOutlineIcon
              className={classes.removeCircleOutlineIcon}
            />
          ) : (
            <AddCircleOutlineIcon className={classes.addCircleOutlineIcon} />
          )
        }
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Typography
          variant="h5"
          color="initial"
          align="left"
          className={classes.questionsWhite}
        >
          {translator("reset_title")}
        </Typography>
      </AccordionSummary>

      <AccordionDetails>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <form className={classes.form} noValidate autoComplete={"off"}>
              <label className={classes.labels}>
                {translator("reset_label")}
              </label>
              <FormControl fullWidth>
                <OutlinedInput
                  className={classes.outlinedInputProfile}
                  type={values.showCurrentPassword ? "text" : "password"}
                  value={values.currentPassword}
                  name="currentPassword"
                  onChange={handleChange}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowCurrentPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                        className={classes.icon}
                      >
                        {values.showCurrentPassword ? (
                          <Visibility />
                        ) : (
                          <VisibilityOff />
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
              {errors?.error_password && (
                <AlertMessage type="error" text={errors.error_password} />
              )}

              <label className={classes.labels}>
                {translator("reset_password")}
              </label>
              <FormControl fullWidth>
                <OutlinedInput
                  className={classes.outlinedInputProfile}
                  type={values.showNewPassword ? "text" : "password"}
                  value={values.newPassword}
                  name="newPassword"
                  onChange={handleChange}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowNewPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                        className={classes.icon}
                      >
                        {values.showNewPassword ? (
                          <Visibility />
                        ) : (
                          <VisibilityOff />
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
              <p className={classes.passwordHelper}>
                {translator("reset_helper")}
              </p>
              {errors?.error_new_password && (
                <AlertMessage type="error" text={errors.error_new_password} />
              )}

              <label className={classes.labels}>
                {translator("reset_newPassword")}
              </label>
              <FormControl fullWidth>
                <OutlinedInput
                  className={classes.outlinedInputProfile}
                  type={values.showConfirmNewPassword ? "text" : "password"}
                  value={values.confirmNewPassword}
                  name="confirmNewPassword"
                  onChange={handleChange}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowConfirmNewPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                        className={classes.icon}
                      >
                        {values.showConfirmNewPassword ? (
                          <Visibility />
                        ) : (
                          <VisibilityOff />
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
              <p className={classes.passwordHelper}>
                {translator("reset_helperPassword")}
              </p>
              {errors?.error_confirm_new_password && (
                <AlertMessage
                  type="error"
                  text={errors.error_confirm_new_password}
                />
              )}
              {errors?.error_no_match_new_password && (
                <AlertMessage
                  type="error"
                  text={errors.error_no_match_new_password}
                />
              )}
            </form>
          </Grid>

          <Grid item xs={12} className={classes.buttonContainer}>
            <ButtonDefault
              type="blue"
              text={translator("reset_button")}
              changeView={changePassword}
              disabled={buttonDisabled}
            />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default ResetPasswordAccordion;
